import React, { useState } from "react";
import Hero from "../Components/Hero";
import Banner from "../Components/Banner";
import { Link } from "react-router-dom";
import RoomsContainer from "../Components/RoomsContainer";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";
const Rooms = () => {

  const [news, setNews] = useState([]);
  const [backgrounds, setBackgrounds] = useState([]);
  var bg = "";
  var info2 = "";
  var info1 = "";
  function setB(typ, text)
  {
    if (typ === "Rooms")
    {
      bg = text;
    }     
  }  
  function setV(typ, text)
  {
    if (typ === "Info 2")
    {
      info2 = text;
    }
    else if (typ === "Info 1")
    {
      info1 = text;
    }       
  }  
  React.useEffect(() => {
    onValue(ref(db, "/texte/"), (snapshot) => {
      setNews([]);
      const data = snapshot.val();
      if (data !== null) {
        // eslint-disable-next-line array-callback-return
        Object.values(data).map((newst) => {
          setNews((oldArray) => [...oldArray, newst]);
        });
      }
    });
    onValue(ref(db, "/backgrounds/"), (snapshot) => {
      setBackgrounds([]);
      const data = snapshot.val();
      if (data !== null) {
        // eslint-disable-next-line array-callback-return
        Object.values(data).map((newst) => {
          setBackgrounds((oldArray) => [...oldArray, newst]);
        });
      }
    });      
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // eslint-disable-next-line
  {news ?   
    ( 
      // eslint-disable-next-line 
    news.map((newst) =>     
    {
      newst.page === "Zimmer" ?
      setV(newst.text, newst.content)
      : <></>
    }   
          )) : (
<></>
      )}    
backgrounds ?   
    ( 
      // eslint-disable-next-line 
    backgrounds.map((background) =>     
    {
      setB(background.type, background.image)
    }   
          )) : (
<></>
      )   
  return (
    <div>
      {/* eslint-disable react/style-prop-object*/}
      <Hero hero="roomsHero" style={bg}></Hero>
      <Banner title={info1} subtitle={info2}>
        <Link to="/" className="btn btn-warning">
          Zurück zur Startseite
        </Link>
      </Banner>
      <RoomsContainer />
    </div>
  );
};

export default Rooms;
